import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isExternal } from '@/utils/validate';
import { mapState } from 'vuex';
export default {
  props: {
    to: {
      type: String,
      required: true
    },
    url: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: function _default() {}
    },
    parent: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: _objectSpread({}, mapState({
    sidebar: function sidebar(state) {
      return state.app.sidebar;
    }
  })),
  methods: {
    isExternal: isExternal,
    clickRouter: function clickRouter() {
      var url;
      if (this.url.substr(0, 6) === 'PAY://') {
        url = process.env.VUE_APP_BMMS_URL + this.url.substring(6);
      } else {
        url = process.env.VUE_APP_PDS_URL + this.url;
      }
      this.$router.push({
        path: "/iframe/go",
        query: {
          route: "".concat(_JSON$stringify(this.item)),
          parent: _JSON$stringify(this.parent),
          url: url
        }
      });
    },
    linkProps: function linkProps(url) {
      if (isExternal(url)) {
        return {
          is: 'a',
          href: url,
          target: '_blank',
          rel: 'noopener'
        };
      }
      return {
        is: 'router-link',
        to: url
      };
    }
  }
};